import { FilterDefinition } from '../StagingFilterBuilder';
import { LocationTypeFilter } from '../../../../redux/constants/filters';
import LocationTypeFilterPopover from './LocationTypeFilterPopover';

export const locationTypeFilter = new FilterDefinition(
  LocationTypeFilterPopover,
  'location_type',
  'Location Type',
  {},
  (type) =>
    new LocationTypeFilter({
      key: 'location_type',
      getter: (e) => e.type,
      type,
    })
);
